module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"answer":"Answer","distribution":"Distribution","amount":"Amount"},"de":{"answer":"Antwort","distribution":"Verteilung","amount":"Anzahl"},"fr":{"answer":"Réponse","distribution":"Distribution","amount":"Nombre"},"it":{"answer":"Risposta","distribution":"Distribuzione","amount":"Numero"}}')
  delete Component.options._Ctor
}
